import { useTranslation } from '@rhino-project/core/i18n';
import { useWatch } from 'react-hook-form';

import { useEffect, useMemo } from 'react';
import { filterPillText, useModelFilterField } from '../../../form';
import { useModelFiltersContext } from '@rhino-project/core/hooks';
import { FilterYear } from '../../../Filter';

export const ModelFilterYear = ({
  path,
  ...props
}: {
  path: string;
  [key: string]: unknown;
}) => {
  const { t } = useTranslation();
  const { attribute, operator, operatorPath, ...rest } =
    useModelFilterField(path);
  const min = useMemo(() => {
    if (!attribute.minimum) return undefined;

    return attribute.exclusiveMinimum
      ? attribute.minimum + 1
      : attribute.minimum;
  }, [attribute]);

  const max = useMemo(() => {
    if (!attribute.maximum) return undefined;

    return attribute.exclusiveMaximum
      ? attribute.maximum - 1
      : attribute.maximum;
  }, [attribute]);

  const watch = useWatch({ name: operatorPath });
  const { setPill } = useModelFiltersContext();

  useEffect(() => {
    if (watch !== undefined && watch !== '')
      setPill(operatorPath, filterPillText(attribute, operator, watch));
  }, [attribute, operator, operatorPath, setPill, watch]);

  return (
    <FilterYear
      path={operatorPath}
      min={min}
      max={max}
      placeholder={t('rhino.frontend.messages.select_a_value', {
        value1: attribute.readableName.toLowerCase()
      })}
      {...rest}
      {...props}
    />
  );
};
